import { REDUCER_NAME } from "./consts";

export const selectors = {
  selectEventType: (state) => state[REDUCER_NAME].eventType,
  selectIsSubmitActive: (state) => state[REDUCER_NAME].isSubmitActive,
};
